/**
 * Color model of an image
 * @typedef {('GREY'|'RGB'|'HSL'|'HSV'|'CMYK')} ColorModel
 */

export const GREY = 'GREY';
export const RGB = 'RGB';
export const HSL = 'HSL';
export const HSV = 'HSV';
export const CMYK = 'CMYK';
